<template>
  <div>
    <div class="fix-wrapper">
      <breadcrumb
        v-if="type == 'rent'"
        :crumbs="[$t('menu.rents'), $t('text.create')]"
      ></breadcrumb>
      <breadcrumb
        v-else
        :crumbs="[$t('menu.cleans'), $t('text.create')]"
      ></breadcrumb>

      <div class="container">
        <el-form
          ref="rentItemForm"
          :model="rentItem"
          label-width="100px"
          size="small"
        >
          <div class="pd20">
            <fieldset>
              <legend>
                {{ $t("text.baseInfo") }}
                <span v-if="type == 'rent'" class="float-right">
                  {{ $t("order.subtotal") }}:
                  {{ (rentItem.price * rentItem.quantity) | currency }}
                </span>
              </legend>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item
                    :label="
                      type == 'rent'
                        ? $t('rent.serialNo')
                        : $t('clean.serialNo')
                    "
                    :prop="'serialNo'"
                    :rules="[
                      {
                        required: true,
                        validator: validateSerialNo,
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-input
                      size="small"
                      v-model.trim="rentItem.serialNo"
                      :placeholder="$t('prompt.alphabetNumberLine')"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    :label="$t('product.productNo')"
                    :prop="'productNo'"
                    :rules="[
                      {
                        required: true,
                        message: $t('rules.required', [
                          $t('product.productNo'),
                        ]),
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-autocomplete
                      v-model.trim="rentItem.productNo"
                      :fetch-suggestions="querySearchProductNo"
                      :trigger-on-focus="false"
                      style="width: 100%"
                      @select="handleSelectProductNo"
                    >
                      <template slot-scope="{ item }">
                        <div class="name">{{ item.productNo }}</div>
                        <span class="addr">{{ item.productNoAlias }}</span>
                      </template>
                    </el-autocomplete>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('product.size')" :prop="'size'">
                    <el-autocomplete
                      size="small"
                      v-model.trim="rentItem.size"
                      :fetch-suggestions="querySearchSize"
                      style="width: 100%"
                      @select="handleSelectSize"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item :label="$t('product.color')" :prop="'color'">
                    <el-autocomplete
                      size="small"
                      v-model.trim="rentItem.color"
                      :fetch-suggestions="querySearchColor"
                      style="width: 100%"
                      @select="handleSelectColor"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8" v-if="type == 'rent'">
                  <el-form-item
                    :label="$t('rentItem.price')"
                    :prop="'price'"
                    :rules="[
                      {
                        required: true,
                        message: $t('rules.required', [$t('order.price')]),
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-input size="small" v-model.trim="rentItem.price">
                      <div slot="append">售 {{ CNYPrice | currency }}</div>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    :label="$t('text.quantity')"
                    :prop="'quantity'"
                    :rules="[
                      {
                        required: true,
                        message: $t('rules.required', [$t('text.quantity')]),
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-input
                      size="small"
                      v-model.trim="rentItem.quantity"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </fieldset>
            <el-row :gutter="20">
              <el-col :span="10">
                <fieldset>
                  <legend>
                    {{ $t("product.images") }}
                    <svg-icon icon-class="link" @click="linkImage" />
                  </legend>
                  <dropzone v-model="rentItem.images" multiple />
                </fieldset>
              </el-col>
              <el-col :span="14">
                <fieldset>
                  <legend>{{ $t("text.remark") }}</legend>
                </fieldset>
                <el-input
                  v-model="rentItem.remark"
                  type="textarea"
                  :rows="4"
                ></el-input>
              </el-col>
            </el-row>
          </div>
          <div class="form-footer">
            <el-button
              type="primary"
              plain
              :loading="saveDoing"
              size="medium"
              @click="save"
              >{{ $t("text.submit") }}</el-button
            >
            <back-button />
          </div>
        </el-form>
      </div>
    </div>

    <el-dialog
      :title="$t('action.linkImage')"
      :visible.sync="linkImageDF"
      :close-on-click-modal="false"
      width="50%"
    >
      <el-form ref="linkImageForm" :model="linkImageObj">
        <el-form-item
          :prop="'linkImageStr'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('action.linkImage')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            v-model="linkImageObj.linkImageStr"
            :placeholder="$t('prompt.linkImageExplain')"
            type="textarea"
            :autosize="{ minRows: 4, maxRows: 10 }"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="linkImageDoing"
          size="small"
          @click="linkImageSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="linkImageDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import Util from "@/utils/index.js";
import { page } from "@/utils/mixins.js";
import Dropzone from "@/components/Dropzone";
import BackButton from "@/components/BackButton";

//
import Rent from "@/api/rent.js";
import RentItem from "@/api/rentItem.js";
import Size from "@/api/size.js";
import Color from "@/api/color.js";
import Product from "@/api/product.js";

export default {
  components: {
    Dropzone,
    BackButton,
  },
  mixins: [page],
  data() {
    var validateSerialNo = (rule, value, callback) => {
      const self = this;
      if (value === null || value.trim() === "") {
        callback(
          new Error(this.$t("rules.required", [this.$t("rentItem.serialNo")]))
        );
        return;
      }
      if (!Util.regexAlphabetNumberLine(value)) {
        callback(new Error(this.$t("prompt.regexAlphabetNumberLine")));
        return;
      }
      RentItem.findBySerialNo({ serialNo: value }).then(function (res) {
        if (res.data.code === 200) {
          callback(
            new Error(self.$t("rules.exist", [self.$t("rentItem.serialNo")]))
          );
        } else {
          callback();
        }
      });
    };

    return {
      validateSerialNo: validateSerialNo,
      type: null,
      rentItem: {
        rentId: null,
        serialNo: null,
        productNo: null,
        color: null,
        size: null,
        quantity: null,
        unit: null,
        price: null,
        images: null,
        remark: null,
      },

      saveDoing: false,
      rent: null,
      sizes: [],
      colors: [],

      products: [],
      productNoColors: [],
      productNoSizes: [],
      productSalesPrice: null,
      CNYPrice: null,
      // 图片链接
      linkImageDF: false,
      linkImageObj: {
        linkImageStr: null,
      },
      linkImageDoing: false,
    };
  },
  mounted() {},
  created() {
    const self = this;
    self.type = self.$route.query.type;
    axios
      .all([
        Rent.findById(self.$route.params.id),

        Size.findByTenantId(),
        Color.findByTenantId(),
      ])
      .then(
        axios.spread(function (rent, sizes, colors) {
          if (rent.status === 200) {
            self.rent = rent.data.entity;
            self.rentItem.rentId = self.rent.id;
            self.rentItem.serialNo =
              self.rent.serialNo + "-" + (self.rent.rentItems.length + 1);
          } else {
            self.sysError();
          }
          if (sizes.status === 200) {
            self.sizes = sizes.data;
          } else {
            self.sysError();
          }
          if (colors.status === 200) {
            self.colors = colors.data;
          } else {
            self.sysError();
          }
        })
      );
  },

  methods: {
    // 图片链接
    linkImage() {
      this.linkImageDF = true;
      this.linkImageObj.linkImageStr = null;
    },
    linkImageSubmit() {
      const self = this;
      this.$refs.linkImageForm.validate((valid) => {
        if (valid) {
          const linkImageArr = this.linkImageObj.linkImageStr.split("\n");
          const linkImageArrFilter = linkImageArr.filter((a) => a != null);
          if (self.rentItem.images == null) {
            self.rentItem.images = linkImageArrFilter.join(";");
          } else {
            self.rentItem.images =
              self.rentItem.images + ";" + linkImageArrFilter.join(";");
          }
          this.linkImageDF = false;
        } else {
          return false;
        }
      });
    },

    // 货号
    querySearchProductNo(queryString, cb) {
      const self = this;
      //
      self.rentItem.color = null;
      self.rentItem.size = null;
      self.rentItem.images = null;
      self.rentItem.remark = null;
      self.rentItem.price = null;
      self.productSalesPrice = null;
      self.productSizePrices = null;
      self.productNoColors = [];
      self.productNoSizes = [];
      //
      if (queryString == null || queryString.length < 1) {
        return;
      }
      Product.vagueFindByProductNo({ productNo: queryString }).then(function (
        res
      ) {
        self.products = res.data;
        if (self.products.length !== 0) {
          for (const p of self.products) {
            Vue.set(p, "value", p.productNo);
          }
        }
        cb(self.products);
      });
    },
    handleSelectProductNo(item) {
      const self = this;
      self.rentItem.productNo = item.productNo;
      self.rentItem.color = null;
      self.rentItem.size = null;
      self.rentItem.images = item.images;
      self.rentItem.unit = item.unit;
      self.productNoColors = item.colors;
      self.productNoSizes = item.sizes;
      self.productSalesPrice = item.salesPrice;
      self.CNYPrice = item.salesPrice;
      self.productSizePrices = item.productSizePrices;
    },
    // 颜色
    querySearchColor(queryString, cb) {
      const colors =
        this.productNoColors.length !== 0
          ? this.productNoColors.map((pc) => {
              return { value: pc };
            })
          : this.colors.map((c) => {
              return { value: c.name };
            });
      if (queryString == null) {
        cb(colors);
      } else {
        cb(colors.filter((c) => c.value.indexOf(queryString) !== -1));
      }
    },
    handleSelectColor() {
      this.rentItem.color = Util.jyTrim(this.rentItem.color);
    },
    // 规格
    querySearchSize(queryString, cb) {
      const self = this;
      let sizes = [];
      if (self.productNoSizes.length !== 0) {
        sizes = this.productNoSizes.map((pc) => {
          return { value: pc };
        });
      } else {
        sizes = this.sizes.map((c) => {
          return { value: c.name, explain: c.explain };
        });
      }
      if (queryString == null) {
        cb(sizes);
      } else {
        cb(sizes.filter((c) => c.value.indexOf(queryString) !== -1));
      }
    },
    handleSelectSize() {
      const self = this;
      self.rentItem.size = Util.jyTrim(self.rentItem.size);
      // 产品规格售价
      if (
        self.productSizePrices.length != 0 &&
        self.productSizePrices.find((s) => s.size === this.rentItem.size)
      ) {
        self.CNYPrice = self.productSizePrices.find(
          (s) => s.size === this.rentItem.size
        ).salesPrice;
        return;
      } else {
        self.CNYPrice = self.productSalesPrice;
      }
    },

    //
    save() {
      let self = this;
      self.$refs.rentItemForm.validate((valid) => {
        if (valid) {
          if (self.type == "rent" && !Util.regexPrice(self.rentItem.price)) {
            self.$message({
              message: self.$t("rules.regex", [self.$t("rentItem.price")]),
              type: "warning",
            });
            return;
          }
          if (
            !Util.regexQuantity(self.rentItem.quantity) ||
            self.rentItem.quantity === "0"
          ) {
            self.$message({
              message: self.$t("rules.regex", [self.$t("text.quantity")]),
              type: "warning",
            });
            return;
          }
          self.rentItem.color = Util.jyTrim(self.rentItem.color);
          self.rentItem.size = Util.jyTrim(self.rentItem.size);

          self.saveDoing = true;
          RentItem.insertBatch([self.rentItem]).then(function (res) {
            self.saveDoing = false;

            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.saveSuccess"),
                type: "success",
              });
              self.$router.push({ name: "rents" });
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.name {
  text-overflow: ellipsis;
  overflow: hidden;
}
.addr {
  font-size: 12px;
  color: #b4b4b4;
}
</style>